import { Map, Record, fromJS } from "immutable";
import idx from "idx";

const State = Record({
  offers: new Map({}),
  applications: new Map({}),
  agencies: new Map({})
});

const reducer = (state = new State(), action) => {
  const entities = idx(action, _ => _.payload.data.entities);
  if (entities) {
    return state.mergeDeep(fromJS(entities));
  }

  return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/entities/reducer.js